<template>
    <!-- Paso 2: huésped o anfitrión. Elegir una opción guarda y pasa al paso 3. -->
    <section class="bk-card" aria-labelledby="rg-type">
        <header class="bk-card-head">
            <span class="bk-step" aria-hidden="true">2</span>
            <div>
                <h2 id="rg-type" class="bk-card-title">{{ $t('auth_nuevo.reg.type.title') }}</h2>
                <p class="bk-card-desc">{{ $t('auth_nuevo.reg.type.desc') }}</p>
            </div>
        </header>

        <div v-if="error" class="bk-auth-alert" role="alert"><p>{{ error }}</p></div>

        <div class="bk-auth-options">
            <button
                v-for="op in opciones"
                :key="op.tipo"
                type="button"
                :class="['bk-auth-option', { 'is-loading': guardando === op.tipo }]"
                :disabled="!!guardando"
                :aria-busy="guardando === op.tipo ? 'true' : 'false'"
                @click="selectProfileType(op.tipo)"
            >
                <span class="bk-auth-option-ico" aria-hidden="true" v-html="op.icono"></span>
                <span class="bk-auth-option-txt">
                    <span class="bk-auth-option-title">{{ $t(`auth_nuevo.reg.${op.clave}.title`) }}</span>
                    <span class="bk-auth-option-desc">{{ $t(`auth_nuevo.reg.${op.clave}.desc`) }}</span>
                </span>
                <span class="bk-auth-option-go" aria-hidden="true">
                    <span v-if="guardando === op.tipo" class="bk-spinner"></span>
                    <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 6 6 6-6 6" /></svg>
                </span>
            </button>
        </div>
    </section>
</template>

<script>

import { mapActions } from "vuex";

// Lupa sobre una casa (huésped) y llave (anfitrión).
const ICONO_HUESPED = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="10.5" cy="10.5" r="6.5"/><path d="m20 20-4.6-4.6"/><path d="M7.5 11.5 10.5 9l3 2.5V14h-6z"/></svg>';
const ICONO_ANFITRION = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 10.5 12 3l9 7.5"/><path d="M5 9v11h14V9"/><circle cx="12" cy="14" r="2"/><path d="M12 16v3"/></svg>';

export default {
    name: "Step2",
    data() {
        return {
            opciones: [
                { tipo: 'huesped', clave: 'guest', icono: ICONO_HUESPED },
                { tipo: 'anfitrion', clave: 'host', icono: ICONO_ANFITRION }
            ],
            // Tipo que se está guardando (null si ninguno).
            guardando: null,
            error: ''
        };
    },
    methods: {

        ...mapActions("userNew", [
            "setUserType"
        ]),

        async selectProfileType(profileType) {
            if (this.guardando) return;
            this.guardando = profileType;
            this.error = '';
            try {
                await this.setUserType({ 'type': profileType });
                // El paso 3 lo manda a la API como "Tipo de lead".
                localStorage.setItem('userType', profileType === 'anfitrion' ? 'Anfitrión' : 'Huésped');
                this.$emit('next-step');
            } catch (error) {
                console.error('Error actualizando el tipo de perfil:', error);
                this.error = error && error.response ? this.$t('auth_nuevo.reg.err_type') : this.$t('auth_nuevo.err.network');
            } finally {
                this.guardando = null;
            }
        }
    }
}

</script>
